let scrollPanel = new Phaser.Scene("ScrollPanel");

scrollPanel.init = function () {
    this.gameW = this.sys.game.config.width;
    this.gameH = this.sys.game.config.height;
}

scrollPanel.create = function () {

    this.add.image(this.gameW / 2, this.gameH / 2, 'background');
    let topBar = this.add.image(this.gameW / 2, 100, 'button').setScale(5, 1);



    console.log("CreatePanel")
    // Get the Phaser game container
    let gameContainer = document.getElementById("game");

    // Remove any existing scroll panel before adding a new one (prevents duplicates)
    let oldPanel = document.getElementById("scroll-panel");
    if (oldPanel) oldPanel.remove();

    // Create the scroll panel
    const scrollPanel = document.createElement("div");
    scrollPanel.id = "scroll-panel"; // Unique ID for easy removal later
    scrollPanel.style.position = "absolute";
    scrollPanel.style.width = "380px";
    scrollPanel.style.height = "300px";
    scrollPanel.style.overflowY = "auto";
    scrollPanel.style.borderRadius = "10px"; // Rounded corners
    scrollPanel.style.border = "2px solid #555"; // Subtle border
    scrollPanel.style.padding = "15px";
    scrollPanel.style.background = "#fff"; // Light background
    scrollPanel.style.color = "#11044E"; // Dark text
    scrollPanel.style.boxShadow = "4px 4px 10px rgba(0,0,0,0.3)"; // Soft shadow
    scrollPanel.style.fontFamily = "Arial, sans-serif";
    scrollPanel.style.fontSize = "16px";
    scrollPanel.style.zIndex = "50"; // Ensure it's above Phaser canvas
    scrollPanel.style.scale = "1.2";

    // Centering it inside the game
    let rect = gameContainer.getBoundingClientRect();
    scrollPanel.style.left = `${rect.left + rect.width / 2 - this.gameW / 10}px`;
    scrollPanel.style.top = `${rect.top + rect.height / 2 - this.gameH / 10}px`;
    // scrollPanel.style.left = "50%";
    // scrollPanel.style.top = "50%";
    // scrollPanel.style.transform = "translate(-50%, -50%)";

    // Create a form
    const form = document.createElement("form");

    // Add styling for form elements
    const inputStyle = `
         input[type="radio"], select, input[type="text"], button {
             padding: 8px;
             margin: 5px 0;
             border-radius: 5px;
             border: none;
             outline: none;
             font-size: 16px;
         }
         input[type="text"], select {
             width: 50%;
             background: #333;
             color: #fff;
             padding: 10px;
             border: 1px solid #777;
         }
         input[type="radio"] {
             accent-color: #ffcc00; /* Custom color for radio buttons */
         }
         button {
             background: #ffcc00;
             color: black;
             cursor: pointer;
             font-weight: bold;
             width: 100%;
             padding: 10px;
         }
         button:hover {
             background: #ffaa00;
         }
     `;

    // Inject styles into a <style> tag
    const styleTag = document.createElement("style");
    styleTag.innerHTML = inputStyle;
    document.head.appendChild(styleTag);

    // Function to create label-input pair in a single line
    function createInputField(labelText, inputType) {
        let container = document.createElement("div");
        container.style.display = "flex";
        container.style.alignItems = "center";
        container.style.justifyContent = "space-between"; // Ensures label & input are on the same line
        container.style.marginBottom = "10px";

        let label = document.createElement("label");
        label.textContent = labelText;
        label.style.flex = "1"; // Makes label take up equal space

        let input = document.createElement("input");
        input.type = inputType;
        input.style.flex = "2"; // Allows input to take up more space

        container.appendChild(label);
        container.appendChild(input);
        return container;
    }

    // Add nickname input
    form.appendChild(createInputField("Nickname:", "text"));

    // Add creature code input
    form.appendChild(createInputField("Creature Code:", "text"));

    // Create a container for radio buttons with a label
    let radioWrapper = document.createElement("div");
    radioWrapper.style.display = "flex";
    radioWrapper.style.alignItems = "center";
    radioWrapper.style.marginTop = "10px";

    let radioLabel = document.createElement("label");
    radioLabel.textContent = "Size:";
    radioLabel.style.marginRight = "80px"; // Space between label and radios
    radioWrapper.appendChild(radioLabel);

    // Create a container for radio buttons
    let radioContainer = document.createElement("div");
    radioContainer.style.display = "flex"; // Align items in a row
    radioContainer.style.gap = "10px"; // Space between options

    // Radio button labels
    const radioOptions = ["Small", "Medium", "Large"];

    radioOptions.forEach((option, index) => {
        let label = document.createElement("label");
        label.style.display = "flex"; // Align radio button & text
        label.style.alignItems = "center"; // Center vertically
        label.style.gap = "5px";

        let radio = document.createElement("input");
        radio.type = "radio";
        radio.name = "sizeOption"; // All radios must have the same name
        radio.value = option.toLowerCase();

        label.appendChild(radio);
        label.appendChild(document.createTextNode(` ${option}`));
        radioContainer.appendChild(label);
    });

    // Append the radio container to its wrapper
    radioWrapper.appendChild(radioContainer);
    form.appendChild(radioWrapper);

    //container for dropDown
    let dropdownWrapper = document.createElement("div");
    dropdownWrapper.style.display = "flex";
    dropdownWrapper.style.alignItems = "center";
    dropdownWrapper.style.marginTop = "10px";

    // Create dropdown
    let dropdownLabel = document.createElement("label");
    dropdownLabel.textContent = "Colour:";
    dropdownLabel.style.marginRight = "65px";
    dropdownWrapper.appendChild(dropdownLabel);

    let dropdown = document.createElement("select");
    let options = ["Orange", "Pink", "Purple", "Blue"];
    options.forEach((opt, index) => {
        let option = document.createElement("option");
        option.value = index + 1;
        option.textContent = opt;
        dropdown.appendChild(option);
    });

    dropdownWrapper.appendChild(dropdown);


    // Append dropdown
    form.appendChild(dropdownWrapper);

    let checkboxWrapper = document.createElement("div");
    checkboxWrapper.style.display = "flex";
    checkboxWrapper.style.alignItems = "center";
    checkboxWrapper.style.marginTop = "10px";

    let checkboxLabel = document.createElement("label");
    checkboxLabel.textContent = "Coat Pattern:";
    checkboxLabel.style.marginRight = "25px"; // Space between label and radios
    checkboxWrapper.appendChild(checkboxLabel);

    // Create a container for radio buttons
    let checkboxContainer = document.createElement("div");
    checkboxContainer.style.display = "flex"; // Align items in a row
    checkboxContainer.style.gap = "10px"; // Space between options

    // Radio button labels
    const checkboxOptions = ["spots", "stripes", "none"];

    checkboxOptions.forEach((option, index) => {
        let label = document.createElement("label");
        label.style.display = "flex"; // Align radio button & text
        label.style.alignItems = "center"; // Center vertically
        label.style.gap = "5px";

        let checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.name = "patternOption"; // All radios must have the same name
        checkbox.value = option.toLowerCase();

        label.appendChild(checkbox);
        label.appendChild(document.createTextNode(` ${option}`));
        checkboxContainer.appendChild(label);
    });

    // Append the radio container to its wrapper
    checkboxWrapper.appendChild(checkboxContainer);
    form.appendChild(checkboxWrapper);

    /////////////
    //container for dropDown
    let dropdownWrapper02 = document.createElement("div");
    dropdownWrapper02.style.display = "flex";
    dropdownWrapper02.style.alignItems = "center";
    dropdownWrapper02.style.marginTop = "10px";

    // Create dropdown
    let dropdownLabel02 = document.createElement("label");
    dropdownLabel02.textContent = "Planet found on";
    dropdownLabel02.style.marginRight = "05px";
    dropdownWrapper02.appendChild(dropdownLabel02);

    let dropdown02 = document.createElement("select");
    let options02 = ["Jupiter", "Saturn", "Mars", "Earth"];
    options02.forEach((opt, index) => {
        let option = document.createElement("option");
        option.value = index + 1;
        option.textContent = opt;
        dropdown02.appendChild(option);
    });

    dropdownWrapper02.appendChild(dropdown02);


    // Append dropdown
    form.appendChild(dropdownWrapper02);

    // Add Date Picker (Calendar)
    form.appendChild(createInputField("Select Date:", "date"));

    // Add Time Picker (Clock)
    form.appendChild(createInputField("Select Time:", "time"));

    // Add submit button
    let submitButton = document.createElement("button");
    submitButton.type = "submit";
    submitButton.textContent = "Submit";
    submitButton.style.marginTop = "15px";

    // Append form elements to scroll panel
    form.appendChild(submitButton);
    scrollPanel.appendChild(form);

    // Append scroll panel inside Phaser game container
    gameContainer.appendChild(scrollPanel);

    console.log("Done");


};

